import PropTypes from "prop-types";
import React from "react";
import { CardHeader } from "reactstrap";
import Sticky from "react-stickynode";
import __ from "src/utils/Translations";

export default function FormTitle({
  stickyTitle,
  title,
  buttons,
  leftButtons,
  translateTitle,
}) {
  return (
    <Sticky
      enabled={stickyTitle}
      top=".app-header"
      activeClass="sticky-active-class"
    >
      {leftButtons ? (
        <CardHeader className="card-header-lg text-transform-none flex-column align-items-stretch">
          <div className="card-header-title font-size-lg font-weight-normal mb-2">
            {translateTitle ? __(title) : title}
          </div>
          <div className="d-flex align-items-center w-100">
            <div className="btn-actions-pane-left">{leftButtons}</div>
            <div className="btn-actions-pane-right">{buttons}</div>
          </div>
        </CardHeader>
      ) : (
        <CardHeader className="card-header-lg text-transform-none">
          <div className="card-header-title font-size-lg font-weight-normal">
            {translateTitle ? __(title) : title}
          </div>
          <div className="btn-actions-pane-right">{buttons}</div>
        </CardHeader>
      )}
    </Sticky>
  );
}

FormTitle.propTypes = {
  buttons: PropTypes.node,
  leftButtons: PropTypes.node,
  stickyTitle: PropTypes.bool,
  translateTitle: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

FormTitle.defaultProps = {
  buttons: [],
  leftButtons: null,
  stickyTitle: false,
  translateTitle: false,
  title: "",
};
